const URL = "https://devapi.otrtcalaveras.com";

export {URL}